import RadioButton from 'components/shared/RadioButton';
import { Heading1, Heading3 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useState } from 'react';
import MostWantedLanguages from './charts/MostWantedLanguages';
import MostWantedTechnologies from './charts/MostWantedTechnologies';
import {
  StyledContainer,
  StyledHeader,
  StyledHighlight,
  StyledSection,
  StyledSubsection,
  StyledSubsectionHeader,
  StyledSwitcher
} from './CompaniesSection.styled';
import LocationsOffered from './LocationsOffered';

const CompaniesSection: React.FC = () => {
  const { t } = useI18n('state-of-the-sector');

  const [mostWantedLangs, setMostWantedLangs] = useState(true);

  return (
    <StyledSection>
      <StyledContainer>
        <StyledHeader>
          <Heading1 as="h2" editorial>
            {t('companies.title')}
          </Heading1>
          <p>{t('companies.desc')}</p>
        </StyledHeader>
        <StyledSubsection>
          <StyledSubsectionHeader>
            <Heading3>{t('companies.most-wanted.title')}</Heading3>
            <p>{t('companies.most-wanted.desc')}</p>
          </StyledSubsectionHeader>
          <StyledSwitcher>
            <RadioButton
              name="mostWantedTechs"
              id="mostWantedLangs"
              label={t('companies.most-wanted.switcher.languages')}
              onChange={() => setMostWantedLangs(true)}
              checked={mostWantedLangs}
            />
            <RadioButton
              name="mostWantedTechs"
              id="mostWantedTechs"
              label={t('companies.most-wanted.switcher.technologies')}
              onChange={() => setMostWantedLangs(false)}
              checked={!mostWantedLangs}
            />
          </StyledSwitcher>
          {mostWantedLangs && <MostWantedLanguages />}
          {!mostWantedLangs && <MostWantedTechnologies />}
        </StyledSubsection>
        <LocationsOffered />
      </StyledContainer>
      <StyledHighlight>
        <p>{t('companies.highlight')}</p>
      </StyledHighlight>
    </StyledSection>
  );
};

export default CompaniesSection;
